

async function DeleteOutwardEntry (outwardItems, projectData)  {

}


export default DeleteOutwardEntry;